import { base_colorContentBorder } from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export const composer = css`
  border: 1px solid ${base_colorContentBorder};
  border-radius: ${spacing(2)};
  display: flex;
  flex-direction: column;
  gap: ${spacing(3)};
  max-width: ${spacing(100)};
  padding: ${spacing(4)};
  width: 100%;
`

export const actions = css`
  display: flex;
  gap: ${spacing(2)};
  justify-content: flex-end;
`

export const error = css`
  margin: 0;
`
